<template>
	<div>
		<b-dropdown id="dropdown_user_notif"  variant="outline-success"  no-caret >
			<template  v-slot:button-content>
				<div :title="user.name" class="header-icon d-flex align-items-center justify-content-center ml-2 js-waves-off">
					<span class="icon-stack fs-xxl">
						<i class="base-2 icon-stack-3x color-primary-400"></i>
						<i class="base-10 text-white icon-stack-1x"></i>
						<i class="ni md-profile color-primary-800 icon-stack-2x"></i>
                	</span>

				</div>
			</template>

			<b-dropdown-form>
				<div class="">
					<div class="dropdown-header bg-trans-gradient d-flex flex-row py-4 rounded-top">
						<div class="d-flex flex-row align-items-center mt-1 mb-1 color-white">
							<div class="info-card-text">
								<div class="fs-lg text-truncate text-truncate-lg">
									{{user.name}}
								</div>
								<span class="text-truncate text-truncate-md opacity-80">
                                    {{user.email}}
                                </span>
							</div>
						</div>
					</div>

					<div class="dropdown-divider m-0"></div>
					<a href="/user/profile" class="dropdown-item" >
                        <span data-i18n="drpdwn.reset_layout">
                          	{{__t('USER_PROFILE')}}
                        </span>
					</a>

					<div class="dropdown-divider m-0"></div>
					<a href="#" class="dropdown-item" data-action="app-fullscreen">
                        <span data-i18n="drpdwn.fullscreen">
							{{__t('FULL_SCREEN')}}
                        </span>
						<i class="float-right text-muted fw-n">F11</i>
					</a>
					<div class="dropdown-divider m-0"></div>

					<a class="dropdown-item fw-500 pt-3 pb-3" @click.stop.prevent="logout">
						<span data-i18n="drpdwn.page-logout">
							{{__t('USER_EXIT')}}
						</span>
					</a>
				</div>
			</b-dropdown-form>

		</b-dropdown>

	</div>
</template>

<script>
import {createHelpers} from 'vuex-map-fields';
const {mapFields} = createHelpers({
	getterType: 'user/getUserField',
	mutationType: 'user/updateUserField',
});

export default {
	name: "user_profiler",

	computed : {
		...mapFields([
			'user',
			'module'
		]),
	},
	methods : {
		async logout() {
			_core.showloading();
			await api.post('/logout').then(({data}) => {
				_core.hideloading();
				window.location.reload();
			});
		}
	}
}
</script>

<style scoped>

</style>
